import React, { useCallback, useId } from 'react';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../_helpers';
import PopperDropdownManager from '@wix/da-ds/pkg/Dropdown/PopperDropdownLayout/PopperDropdownManager';
import PopperDropdownToggle from '@wix/da-ds/pkg/Dropdown/PopperDropdownLayout/PopperDropdownToggle';
import StandardDropdownMenu from '@wix/da-ds/pkg/Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { useDropdownItems } from '@wix/da-ds/pkg/Dropdown/hooks/useDropdownItems';
import s from './ThumbActions.scss';
const ThumbActions = ({ deviation, actions, className, children, onOpen })=>{
    const dropdownId = useId();
    const logger = useBiLogger();
    const { filteredItems } = useDropdownItems(actions);
    const typeid = getDeviationResourceType(deviation);
    const handleOpen = useCallback(()=>{
        if (!(deviation === null || deviation === void 0 ? void 0 : deviation.deviationId)) {
            return;
        }
        logger(BiData({
            evid: 417,
            typeid,
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            feed_mode: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            is_grouped: BiContextProvidedValue
        }));
        onOpen && onOpen();
    }, [
        logger,
        typeid,
        deviation === null || deviation === void 0 ? void 0 : deviation.deviationId,
        onOpen
    ]);
    if (!filteredItems.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        onOpen: handleOpen
    }, /*#__PURE__*/ React.createElement(PopperDropdownToggle, {
        className: className,
        "aria-owns": dropdownId
    }, children), /*#__PURE__*/ React.createElement(StandardDropdownMenu, {
        id: dropdownId,
        items: filteredItems,
        role: "menu",
        className: s['menu']
    }));
};
ThumbActions.displayName = 'ThumbActions';
export default ThumbActions;

//# sourceMappingURL=ThumbActions.js.map